import { render } from "./App.vue?vue&type=template&id=3a0c8e2f"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3a0c8e2f&lang=css"
script.render = render

export default script